import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import UnitConstants from '../../common/unit-constant';
import { DEFAULT_NUMBER_DECIMAL } from "../../common/constants";

@Component({
    template: require('./template.html'),
    components: {
    },

    mounted() {
        if (this.autofocus) {
            (this.$refs.input as any).focus(true);
        }
    }
})
class InputNumberFormattedComponent extends Vue {

    private readonly PATHTERN_INT: number = 0;
    private readonly PATHTERN_DEC: number = 0.00;
    private readonly DEFAULT_TYPE: string = 'decimal';
    @Prop({ default: () => false })
    autofocus: boolean;

    @Prop({ default: () => false })
    disableFormat: boolean;

    dtPreviousKey: number;
    @Prop({ type: [Number, String], default: () => null })
    value: any;

    @Prop({ type: [String], default: 'decimal' })
    type: string

    @Prop({ type: Boolean, default: false })
    minus: boolean;

    @Prop({ default: () => null, type: [Number, String] })
    placeHolder: number | string;

    @Prop({ type: Boolean, default: false })
    disabled: boolean;
    @Prop({ type: [Number, String], default: () => null }) unit;
    @Prop({ type: [Number, String], default: () => null }) maxlength;
    @Prop({ type: [Number], default: () => null }) integerDigits;

    @Prop({ type: [String], default: null })
    size: string


    get coDefaultValue(): number {
        return this.type === this.DEFAULT_TYPE ? this.PATHTERN_DEC : this.PATHTERN_INT
    }
    get coSquareMetre() { return UnitConstants.SQUARE_METRE == this.unit }
    get coMetre() { return UnitConstants.METRE == this.unit }
    get coCubicMetre() { return UnitConstants.CUBIC_METRE == this.unit }
    get coLitre() { return UnitConstants.LITRE == this.unit }
    get coCurrency() { return UnitConstants.CURRENCY == this.unit }
    get coPercent() { return UnitConstants.PERCENT == this.unit }
    get coPicoliter() { return UnitConstants.PICOLITER == this.unit }
    get coEnergy() { return UnitConstants.ENERGY == this.unit }
    get coEPCTotal() { return UnitConstants.EPC_TOTAL == this.unit }
    get coKilogram() { return UnitConstants.KILOGRAM == this.unit }
    get coSquareMetrePerYear() { return UnitConstants.SQUARE_METRE_PER_YEAR == this.unit }

    get coPlaceholder(): string {
        if (this.placeHolder === null)
            return Intl.NumberFormat(this.$i18n.locale).format(this.coDefaultValue);
        if (typeof (this.placeHolder) === 'string') return this.placeHolder;
        else
            return Intl.NumberFormat(this.$i18n.locale).format(this.placeHolder)
    }

    get format(): string[] {
        const pattern = Intl.NumberFormat(this.$i18n.locale).format(-1234.56);
        const results: string[] = [];
        for (let i = 0; i < pattern.length; i++) {
            if (!parseInt(pattern[i])) {
                results.push(pattern[i])
            }
        }
        return results
    }

    get vModel(): string {
        if (this.value === null)
            return '';

        if (this.disableFormat) {
            return this.value.toString();
        }

        if (this.value === this.format[0])
            return this.value;

        return Intl.NumberFormat(this.$i18n.locale, {
            maximumFractionDigits: (this.coType === 'decimal') ? DEFAULT_NUMBER_DECIMAL.maximumFractionDigits : DEFAULT_NUMBER_DECIMAL.minimumFractionDigits
        }).format(this.value)
    }
    set vModel(value: string) {
        if (!!!value) {
            this.$emit('input', value);
            this.$emit('change', value);
            return;
        }
        else {
            let results = value.split(this.format[1]).join("").replace(this.format[2], '.');
            this.$emit('input', parseFloat(results));
            this.$emit('change', parseFloat(results));
        }
    }
    get coType(): string {
        return this.type
    }

    get coMinus(): boolean {
        return this.minus
    }

    get className() {
        if (this.value > 0) {
            return 'has-number'
        } else return ''
    }

    get coSize() {
        return this.size;
    }
    
    handleChange() {
        this.$emit('change', this.value);
    }

    handleBlur() {
        this.$emit('blur', this.value);
    }

    handleEnterPress() {
        this.$emit('enter', this.value);
    }

    /**
   * 4 cases:
   * 1: Check whether the keypress is a number
   * 2: Check whether previous if the seperation
   * 3: Check Whether type === integer and press is not a seperation
   * 4: Check whether the key is the seperation but it does not have the right index in vModel 
   * Example: 123,456,5,5 => Wrong | 1,21,2.3454 => Wrong 
   * Case 4 is not supported yet
   */
    handleKeyPress(event) {
        if (this.hasDecimal(this.value)) {
            let decimalCurrent = this.value.toString().split(".");
            let lengthDecimal = decimalCurrent[decimalCurrent.length - 1].length;
            let { selectionEnd, selectionStart, value } = event.target;
            if (lengthDecimal > 3 && selectionStart > (value.length - 5) && selectionStart === selectionEnd) event.preventDefault();
        }
        if (((this.coType === 'integer') && !this.isNumber(event.key))
            || ((this.coType === 'decimal') && !(this.isNumber(event.key) || this.isDecimalSeparator(event.key)))
            || this.checkConsecutiveFromKey(event)
            || this.isMinus(event.key)
        ) {
            event.preventDefault()
            return
        }
        if (this.maxlength && this.checkMaxLength()) {
            event.preventDefault()
            return
        }
        if (this.format && this.format.indexOf(event.key))
            this.dtPreviousKey = event.keyCode;
    }
    private isNumber(value) {
        let pattern = "[\\d]+"
        let regex = new RegExp(pattern)
        let result = regex.test(value)
        return result;
    }

    private isDecimalSeparator(value) {
        let decimalSeparator = Intl.NumberFormat(this.$i18n.locale).format(1.1).toString().substring(1, 2)
        let pattern = "[\\" + decimalSeparator + "]+"
        let regex = new RegExp(pattern)
        let result = regex.test(value)
        return result;
    }

    private checkMaxLength() {
        if (this.maxlength && this.value)
            return this.value.toString().length > (this.maxlength - 1)
        return false
    }

    // private checkFromKeyCode(event: any) {
    //     return ((event.keyCode < 48 || event.keyCode > 57) && event.keyCode !== 46 && event.keyCode !== 44 && event.keyCode !== 45)
    // }

    // private checkFromKey(key: string) {
    //     return this.coType === 'integer' && key === this.format[2]; /// Compare whether the key is equal seperation of decimal
    // }

    private checkConsecutiveFromKey(event: any) {

        const indexOf = this.format.indexOf(event.key);
        const isDecimalAlready = this.vModel.indexOf(this.format[2]);
        const isMinusAlready = this.vModel.indexOf(this.format[0])
        if (event.key === this.format[0])
            return (isMinusAlready > -1 && indexOf > -1)
        return (indexOf > -1 && event.keyCode === this.dtPreviousKey)
            || (isDecimalAlready > -1 && indexOf > -1);
    }

    private isMinus(key: string) {
        return key === this.format[0] && !this.coMinus
    }

    private hasDecimal(num) {
        return !!(num % 1);
    }

    get coMask() {
        let exp = {
            alias: 'numeric',
            rightAlign: true,
            groupSeparator: this.format[1],
            radixPoint: this.format[2],
            autoGroup: this.disableFormat ? false : true,
            digits: this.type === 'decimal' ? DEFAULT_NUMBER_DECIMAL.maximumFractionDigits : DEFAULT_NUMBER_DECIMAL.minimumFractionDigits,
            allowMinus: this.coMinus ? true : false,
        }
        if (!this.integerDigits || this.integerDigits > 11) {
            exp = Object.assign(exp, {integerDigits: 11})
        } else {
            exp = Object.assign(exp, {integerDigits: this.integerDigits})
        }
        return exp;
    }
}

export default InputNumberFormattedComponent;